import { IsEnum, IsString } from '@pristine-ts/class-validator';
import { CalculationKeynameEnum } from '../../enums/calculations/calculation-keyname.enum';

export abstract class CalculationRunOptions {
  @IsString()
  @IsEnum(CalculationKeynameEnum)
  abstract calculationKeyname: CalculationKeynameEnum;
}
